import React from 'react';
import TwoLineSelect, { TwoLineSelectItem } from './TwoLineSelect';

interface ToolSelectorProps<T = string> {
    label: string;
    placeholder?: string;
    items: TwoLineSelectItem<T>[];
    value: T | undefined | null;
    onChange: (value: T) => void;
    disabled?: boolean;
}

const ToolSelector = function <T>({ label, placeholder, items, value, onChange, disabled }: ToolSelectorProps<T>) {
    return (
        <div>
            <label className="block text-sm font-medium text-layout-textcolor mb-2">{label}</label>
            <TwoLineSelect
                value={value}
                onChange={onChange}
                disabled={disabled}
                placeholder={placeholder}
                items={items}
            />
        </div>
    );
};

export default ToolSelector;
